import React, {
  useEffect,
  useLayoutEffect,
  useState,
  useMemo,
  useRef,
  useCallback,
} from "react";
import { useSelector } from "react-redux";
import { useContextMenu } from "react-contexify";
import {
  ImageOverlay,
  useMapEvents,
  ZoomControl,
  AttributionControl,
} from "react-leaflet";
import { useMaps, useApp } from "../_contexts";

import { MapPin } from "./";

export function StaticMap({ map, animateFancy = false }) {
  // console.log("StaticMap Rendered", map);
  const attributionRef = useRef();
  const mapRef = useRef();
  const { data: chronicle } = useSelector((state) => state.chronicle);
  const { items: markers } = useSelector((state) => state.markers);
  const { items: templates } = useSelector((state) => state.markerTemplates);
  const { items: maps } = useSelector((state) => state.maps);
  const { items: images } = useSelector((state) => state.images);
  const [mapMarkers, setMapMarkers] = useState([]);
  const [bounds, setBounds] = useState([
    [0, 0],
    [800, 800],
  ]);
  const { editMode } = useApp();
  const { coords, currentMap, interactiveMode } = useMaps();

  const { show } = useContextMenu({
    id: "chronos-map-context-menu",
    props: {},
  });

  const { properties } =
    map.image && map.image !== null ? map.image : { properties: undefined };

  const { width, height } = properties ? properties : { width: 0, height: 0 };

  const { options, attribution, attributionLink } = map;

  const leafletMap = useMapEvents({
    contextmenu(e) {
      if (editMode) {
        handleContextClick(e);
      }
    },
    click(e) {
      if (interactiveMode) {
        const markerProps = {
          map: map,
          coords: e.latlng,
          chronicle: chronicle,
          zoom: leafletMap.getZoom(),
        };

        show(e.originalEvent, {
          props: { ...markerProps },
        });
      }
    },
  });

  const handleContextClick = (ev) => {
    show(ev.originalEvent, {
      props: {
        map: map,
        coords: ev.latlng,
        chronicle: chronicle,
        zoom: leafletMap.getZoom(),
      },
    });
    ev.originalEvent.stopPropagation();
  };

  // const bounds = useMemo(() => {
  //   console.log("Calculating Map Bounds", height, width);
  //   return [
  //     [0, 0],
  //     [height, width],
  //   ];
  // }, [map, maps, images]);

  useLayoutEffect(() => {
    console.log("Moving to coords", coords);
    if (animateFancy) {
      const defaultCoords = {
        x: options.coordX,
        y: options.coordY,
        z: options.zoomDefault,
      };
    } else {
      leafletMap.flyTo([coords.y, coords.x], coords.z, {
        animate: true,
        easeLinearity: 0.95,
      });
    }
  }, [coords]);
  //Disabled to prevent "snap-back" (bounds not adjusting correctly)
  // useEffect(() => {
  //   const maxBounds = [
  //     [bounds[0][0] - height / 2, bounds[0][1] - width / 2],
  //     [bounds[1][0] + height / 2, bounds[1][1] + width / 2],
  //   ];
  //   console.log('Max Bounds: ', maxBounds, map);
  //   leafletMap.setMaxBounds(maxBounds);
  // }, [map]);

  useEffect(() => {
    if (markers) {
      const markerComponents = markers.map(({ ...marker }) => {
        if (marker.markerType === "location" && marker.parentMap === map._id) {
          // console.log("Marker", { ...marker });
          return (
            <MapPin
              marker={marker}
              map={map}
              key={marker._id}
              leaflet={leafletMap}
            />
          );
        }
      });

      // console.log('Markers for current MAP', markerComponents);
      setMapMarkers(markerComponents);
      updateMapBounds();
    }
  }, [markers, currentMap, templates, maps]);

  const updateMapBounds = useCallback(() => {
    if (leafletMap) {
      console.log("Setting bounds: ", bounds);
      console.log("Calculating Map Bounds", height, width);
      const newBounds = [
        [0, 0],
        [height, width],
      ];
      setBounds(newBounds);
      // console.log("mapRef", mapRef.current);
      if (mapRef.current) {
        mapRef.current.setBounds(newBounds);
      }
    }
  }, [map]);

  // useEffect(() => {

  // }, [maps, images, map]);

  const errorImage = `https://www.worldanvil.com/images/placeholder-red.jpg`;

  // const MapImage = React.useMemo(() => {
  //   if (map.image?.url) {
  //     return <ImageOverlay url={map.image.url} bounds={bounds} />;
  //   }
  //   if (!map || map.image === null) {
  //     return (
  //       <ImageOverlay
  //         url={errorImage}
  //         bounds={[
  //           [0, 0],
  //           [800, 800],
  //         ]}
  //       />
  //     );
  //   }
  // }, [map, attribution, attributionLink]);

  useEffect(() => {
    if (attribution && attributionRef.current) {
      const prefix = attributionLink
        ? `<a target="_blank" href="${
            attributionLink || "/"
          }">${attribution}</a>`
        : `${attribution}`;
      attributionRef.current.setPrefix(prefix);
    }
  }, [map, attributionLink, maps]);

  return (
    <React.Fragment>
      {map.image?.url && (
        <React.Fragment>
          <ImageOverlay
            ref={mapRef}
            // attribution={attributionText}
            url={map.image.url}
            bounds={bounds}
          />
          {mapMarkers}
        </React.Fragment>
      )}
      {(!map.image || map.image === null) && (
        <React.Fragment>
          <ImageOverlay
            url={errorImage}
            bounds={[
              [0, 0],
              [800, 800],
            ]}
          />
        </React.Fragment>
      )}
      {options.showZoom && <ZoomControl position="topright" />}
      {map.attribution && <AttributionControl ref={attributionRef} />}
    </React.Fragment>
  );
}
